module.exports = __webpack_public_path__ + "media/blog_onboarding_network_transaction.aeda1a30.mp4";